// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  playerId: __t.string().primaryKey().name("player_id"),
  worldId: __t.string().name("world_id"),
  playerName: __t.string().name("player_name"),
  joinedAt: __t.timestamp().name("joined_at"),
  lastSeenAt: __t.timestamp().name("last_seen_at"),
});
